import {
  GET_RESPONSES_BEGIN,
  GET_RESPONSES_SUCCESS,
  GET_RESPONSES_FAILURE,
  RESPONSES_CLEAR,
  SET_QUERY_VALUES,
} from './../../_types'
import analyticsAPI from '@api/analytics'

const getDefaultState = () => {
  return {
    campaignResponses: [
      {
        id: 'demo',
        answer: {
          items: {},
          itemsList: [],
        },
        interactions: [],
        page: '',
        widgetID: '',
        isMobile: false,
        createdAt: 'timestamp',
      },
    ],
    activeSize: 10,
    activePage: 1,
    activeSort: null,
    activeSortDirection: 1,
    getResponsesCompleted: false,
    getResponsesError: false,
    getResponsesLoading: false,
  }
}

export const state = getDefaultState()

export const mutations = {
  [GET_RESPONSES_BEGIN](state) {
    state.getResponsesLoading = true
    state.getResponsesCompleted = false
    state.getResponsesError = false
  },
  [GET_RESPONSES_SUCCESS](state, response) {
    state.getResponsesCompleted = true
    state.getResponsesLoading = false
    state.campaignResponses = response
  },
  [GET_RESPONSES_FAILURE](state) {
    state.getResponsesError = true
    state.getResponsesLoading = false
    state.getResponsesCompleted = true
  },
  [RESPONSES_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_QUERY_VALUES](state, response) {
    state.activeSize = response.size
    state.activePage = response.pageNumber
    state.activeSort = response.sortBy
    state.activeSortDirection = response.sortDirection
  },
}

export const actions = {
  getCampaignResponses(
    { commit, dispatch, rootState },
    { uuid, size = 10, pageNumber = 1, sortBy = null, sortDirection, targetStats = 'impressions' }
  ) {
    commit(GET_RESPONSES_BEGIN)
    commit(SET_QUERY_VALUES, { size, pageNumber, sortBy, sortDirection })

    if (rootState.campaign.currentCampaignsList.length === 0) {
      // There is no campaign for this user
      commit(GET_RESPONSES_SUCCESS, [])

      return
    } else if (!uuid) {
      uuid = rootState.campaign.currentCampaignsList[0].uuid
    }

    let sort
    if (sortBy) {
      sort = (sortDirection < 0 ? '-' : '') + sortBy
    }

    return analyticsAPI
      .getCampaignResponses(uuid, size, pageNumber, sort, targetStats)
      .then((response) => {
        commit(GET_RESPONSES_SUCCESS, response.data)
        dispatch('campaign/setTargetCampaign', uuid, { root: true })
      })
      .catch(() => commit(GET_RESPONSES_FAILURE))
  },
  clearState({ commit }) {
    commit(RESPONSES_CLEAR)
  },
}
